import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import * as Constants from '../../../../config/Constants'
import { searchComureiSubject } from '../../../../actions'
import getText from '../../../shared/i18n/labels'

// TABLE
import { baseSearchObject, fieldTypes, TableUtils } from '../../../shared/tables/TableUtils'
import { StarTable } from '../../../shared/tables/StarTable'

// MODAL
import { CommunicationsHistoryModal } from '../communications/NewCommunicationsHistoryModal'

// FORM
import { ComureiForm } from './NewComureiSubjectForm'

const getTableContainerWidth = () => {
  if (window.innerWidth < Constants.BREAKPOINT_MD) return '200%'
  if (window.innerWidth <= Constants.BREAKPOINT_LG) return '150%'
  return '100%'
}

export function ComureiSubjectList(props) {
  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  const [subjects, setSubjects] = useState([])
  const [loading, setLoading] = useState(false)
  const communicationTypes = useSelector((state) => state.comureiCommunicationTypes.data)

  const [show] = useState(false)
  const [rows, setRows] = useState([])

  const subjectTypes = useSelector((state) => state.comureiSubjectTypes.data)
  const [searchObject, setSearchObject] = useState({
    ...baseSearchObject,
    subjectType: null,
    communicationType: null,
    denomination: null,
    fiscalCode: null,
    responsibleName: null,
    section: null
  })

  const [id, setId] = useState(null)
  const tableUtils = TableUtils
  const tableName = 'comurei-subject'

  const header = [
    tableUtils.composeHeader({
      fieldName: 'subjectType',
      type: fieldTypes.SELECTION,
      options: subjectTypes,
      displayedName: labels.SUBJECT_TYPE,
      maxWidth: '5fr'
    }),
    tableUtils.composeHeader({
      fieldName: 'communicationType',
      type: fieldTypes.SELECTION,
      options: communicationTypes,
      displayedName: labels.COMMUNICATION_TYPE,
      maxWidth: '2.5fr'
    }),
    tableUtils.composeHeader({
      fieldName: 'denomination',
      displayedName: labels.DENOMINATION_OBLIGATED_SUBJECT,
      maxWidth: '3fr'
    }),
    tableUtils.composeHeader({
      fieldName: 'fiscalCode',
      displayedName: labels.FISCAL_CODE,
      maxWidth: '2fr'
    }),
    tableUtils.composeHeader({
      fieldName: 'responsibleName',
      displayedName: labels.RESPONSIBLE,
      maxWidth: '2.5fr'
    }),
    tableUtils.composeHeader({
      fieldName: 'section',
      sortable: false,
      searchable: false,
      displayedName: labels.SECTION,
      maxWidth: '4fr'
    }),
    tableUtils.composeHeader({
      fieldName: 'actions',
      sortable: false,
      searchable: false,
      additionalClass: 'justify-content-center',
      displayedName: labels.HISTORY,
      maxWidth: '1fr'
    })
  ]

  const prepareRows = (newSubjects) => {
    return newSubjects.map((c) => {
      return tableUtils.composeRow({
        id: c.id,
        cellData: {
          subjectType: tableUtils.composeCell({
            fieldName: 'subjectType',
            fieldValue: c.subjectType
          }),
          communicationType: tableUtils.composeCell({
            fieldName: 'communicationType',
            fieldValue: c.communicationType
          }),
          denomination: tableUtils.composeCell({
            fieldName: 'denomination',
            fieldValue: c.denomination
          }),
          fiscalCode: tableUtils.composeCell({
            fieldName: 'fiscalCode',
            fieldValue: c.fiscalCode
          }),
          responsibleName: tableUtils.composeCell({
            fieldName: 'responsibleName',
            fieldValue: c.responsibleName
          }),
          section: tableUtils.composeCell({
            fieldName: 'section',
            fieldValue: c.section
          }),
          actions: tableUtils.composeCell({
            fieldName: 'actions',
            additionalClass: 'd-flex justify-content-center',
            component: () => {
              return (
                <div className="d-flex justify-content-center p-0">
                  <CommunicationsHistoryModal subjectId={c.id} subjectName={c.denomination} />
                </div>
              )
            }
          })
        }
      })
    })
  }

  const reloadRows = (searchObject) => {
    searchComureiSubject(searchObject).then((res) => {
      setSubjects(res.content || res.data)
    })
  }

  const setNewSubjects = (newSubjects) => {
    setSubjects(newSubjects)
    props.setSubjects(newSubjects)
  }

  const onClickRow = (row) => {
    setId(row.id)
  }

  useEffect(() => {
    setRows(prepareRows(subjects))
    setId(id ? id : subjects?.[0]?.id)
  }, [subjects])

  useEffect(() => {
    setId()
  }, [props.resetForm])

  const renderTable = () => {
    return (
      <StarTable
        id={id}
        version="1"
        application="COMUREI"
        hideSearch={props.hideSearch}
        headerComponent={props.headerComponent}
        headerColumns={header}
        rows={rows}
        formOnBottom={true}
        useHover={props.useHover}
        tableContainerWidth={getTableContainerWidth()}
        loading={show}
        tableConfigurationKey={tableName}
        searchObjectPrototype={searchObject}
        setSearchObject={setSearchObject}
        searchCallBack={(searchObject) => {
          setId()
          return searchComureiSubject(searchObject)
        }}
        onExecutedSearch={(content) => setNewSubjects(content)}
        onHideSearch={(val) => props.setHideSearch(val)}
        usePagination={true}
        extraOffset={-10}
        onClickRow={onClickRow}
        formComponent={ComureiForm}
        formComponentProps={{
          disabled: loading || (props.disableNewSubjectButtons && !id),
          formOnBottom: true,
          subjectId: id,
          locations: props.locations,
          subjectTypes: props.subjectTypes,
          openCreateCommunicationModal: props.openCreateCommunicationModal,
          setLoading: setLoading,
          subjectSummary: props.subjectSummary,
          onSaveClick: (subject) => {
            // Da usare solo al click del pulsante salva
            // Riabilitare selezione tramite hover
            // deve ricaricare la lista
            // deve mantenere l'elemento della form
            props.setUseHover(true)
            props.reloadList()
            reloadRows(searchObject)
            setId(subject.id)
          }
        }}
      />
    )
  }

  return <>{subjectTypes?.length > 0 && renderTable()}</>
}
